/**
 * 从浏览器地址认站点码(A18-5「机构绑定了自己的考试域名时,该域名打开显示机构的 Logo 与登录页样式」):
 * 只在「<站点码>.<平台主域名>」上取第一段当站点码;机构自己的域名(如 exam.xxx.edu.cn)不从主机名猜——
 * 原来只要是三段以上的域名就把第一段当站点码(exam / study),会查不到或撞上别家的站点码。
 * 这类域名请求不带站点码头,由服务端按「已审核的自有域名」解析,解析出的站点码再由 /v1/site/tenant 带回来。
 * 平台主域名在构建配置 VITE_PLATFORM_DOMAIN;没配就一律不从主机名猜。
 */
const CODE_RE = /^[a-z][a-z0-9]{3,11}$/;

export function siteCodeFromHost(host: string, platformDomain: string | undefined): string | null {
  const h = host.trim().toLowerCase().replace(/\.$/, '');
  const p = (platformDomain ?? '').trim().toLowerCase().replace(/^\./, '');
  if (!h || !p || h === p) return null;
  const suffix = `.${p}`;
  if (!h.endsWith(suffix)) return null;
  const label = h.slice(0, -suffix.length);
  return !label.includes('.') && CODE_RE.test(label) ? label : null;
}

/** 能当站点码的字符串(切换站点、?site= 用) */
export const isSiteCode = (code: string): boolean => CODE_RE.test(code);
